import { useState } from 'react';

import { MailWarning } from 'lucide-react';

import { Banner } from '@src/components/ui';
import { useMeQuery, useMutation } from '@src/query';


/** Soft-gate: unverified users can use the app, but publishing/inviting stays
 * locked; this persistent banner offers a resend until the email is confirmed. */
function VerifyEmailBanner() {
  const [sent, setSent] = useState(false);
  const { data: me } = useMeQuery();

  const resend = useMutation({
    mutateFn: ({ apiClient, email }) => apiClient.request({
      url: '/users/resend-verification/',
      method: 'POST',
      useAuth: false,
      payload: { email },
    }),
    onSuccess: () => setSent(true),
  });

  if (!me || me.email_verified_at) {
    return null;
  }

  return (
    <Banner
      variant="warning"
      icon={<MailWarning />}
      action={(
        <button
          type="button"
          disabled={sent || resend.isPending}
          className="cursor-pointer disabled:cursor-default disabled:opacity-70"
          onClick={() => resend.mutate({ email: me.email })}
        >
          {sent ? 'Sent — check your inbox' : 'Resend email'}
        </button>
      )}
    >
      Verify your email — publishing and inviting stay locked until you confirm.
    </Banner>
  );
}

VerifyEmailBanner.displayName = 'VerifyEmailBanner';
export default VerifyEmailBanner;
